import { UseMutationResult, useMutation, useQueryClient } from '@tanstack/react-query';

import { OutcomeReview } from '../@types/sla.type';
import { createOutcomeReview } from '../api/sla';
import { OutcomeReviewsKey } from '../configs/sla';

// Creation payload - id is optional since it doesn't exist for new reviews
// Also includes slaIds which is used for batch operations
interface OutcomeReviewCreateData extends Omit<OutcomeReview, 'id'> {
  id?: number;
  slaIds?: number[];
}

export const useCreateOutcomeReview = (
  serviceId: number
): UseMutationResult<void, Error, OutcomeReviewCreateData> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: OutcomeReviewCreateData) => {
      // Extract slaIds (client-side batch property) from the API payload
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { slaIds, ...apiPayload } = data;
      return await createOutcomeReview(serviceId, apiPayload);
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [OutcomeReviewsKey, serviceId],
      });
    },
  });
};
